import {
  EMPLOYEE_PIN_PAGE_REQUEST,
  EMPLOYEE_PIN_ON_SUBMIT_FORM,
  EMPLOYEE_PIN_PIN_REQUEST,
  EMPLOYEE_PIN_SET_SUBMITTING,
  EMPLOYEE_PIN_SET_ALLOWED_FIELDS,
  EMPLOYEE_PIN_SHOW_SAVE_APP_PERMISSION_MODAL,
  EMPLYOEE_PIN_HIDE_SAVE_APP_PERMISSION_MODAL,
  EMPLOYEE_PIN_SET_SAVE_APP_PERMISSION_MODAL,
  EMPLOYEE_PIN_SET_OUTLETS_EMPLOYEES,
  EMPLOYEE_PIN_LIST_OUTLETS_EMPLOYEES_REQUEST,
} from './constants';

export function pageRequest({ user }) {
  return { type: EMPLOYEE_PIN_PAGE_REQUEST, payload: { user } };
}

export function pinRequest({ user }) {
  return { type: EMPLOYEE_PIN_PIN_REQUEST, payload: { user } };
}

export function setAllowedFields({ allowedFields }) {
  return { type: EMPLOYEE_PIN_SET_ALLOWED_FIELDS, payload: { allowedFields } };
}

export function onSubmitForm({ values, user }) {
  return { type: EMPLOYEE_PIN_ON_SUBMIT_FORM, payload: { values, user } };
}

export function setSubmitting({ submitting }) {
  return { type: EMPLOYEE_PIN_SET_SUBMITTING, payload: { submitting } };
}

export function showSaveAppPermissionModal() {
  return { type: EMPLOYEE_PIN_SHOW_SAVE_APP_PERMISSION_MODAL, payload: {} };
}

export function hideSaveAppPermissionModal() {
  return { type: EMPLYOEE_PIN_HIDE_SAVE_APP_PERMISSION_MODAL, payload: {} };
}

export function setSaveAppPermissionModal({ message }) {
  return {
    type: EMPLOYEE_PIN_SET_SAVE_APP_PERMISSION_MODAL,
    payload: { message },
  };
}

export function setOutletsEmployees({ outletsEmployees }) {
  return {
    type: EMPLOYEE_PIN_SET_OUTLETS_EMPLOYEES,
    payload: { outletsEmployees },
  };
}

export function listOutletsEmployeesRequest() {
  return {
    type: EMPLOYEE_PIN_LIST_OUTLETS_EMPLOYEES_REQUEST,
    payload: {},
  };
}
